<template>
    <div class="row no-gutters">
        <div class="col-xl-3 col-md-6">
            <label class="option cursor-pointer" :class="{'option-selected': value === 'file'}">
                <span class="option-control">
                    <span class="radio">
                        <input type="radio"
                               name="import_type"
                               value="file"
                               :checked="'file' === value"
                               @input="$emit('input', 'file')"
                        >
                    </span>
                </span>
                <span class="option-label">
                    <span class="option-head">
                        <span class="option-title">Datei hochladen</span>
                        <span class="option-focus"><i class="fas text-xl fa-upload"/></span>
                    </span>
                    <span class="option-body">
                        Excel, CSV, TSV, XML, ...
                    </span>
                </span>
            </label>
        </div>
        <div class="col-xl-3 col-md-6 pl-md-3">
            <label class="option cursor-pointer" :class="{'option-selected': value === 'url'}">
                <span class="option-control">
                    <span class="radio">
                        <input type="radio"
                               name="import_type"
                               value="url"
                               :checked="'url' === value"
                               @input="$emit('input', 'url')"
                        >
                    </span>
                </span>
                <span class="option-label">
                    <span class="option-head">
                        <span class="option-title">URL</span>
                        <span class="option-focus"><i class="fas text-xl fa-link"/></span>
                    </span>
                    <span class="option-body">
                        Ein Link zur Ressource
                    </span>
                </span>
            </label>
        </div>
<!--        <div class="col-xl-3 col-md-6 pl-xl-3">-->
<!--            <label class="option cursor-pointer" :class="{'option-selected': value === 'ftp'}">-->
<!--                <span class="option-control">-->
<!--                    <span class="radio">-->
<!--                        <input type="radio"-->
<!--                               name="import_type"-->
<!--                               value="ftp"-->
<!--                               :checked="'ftp' === value"-->
<!--                               @input="$emit('input', 'ftp')"-->
<!--                        >-->
<!--                    </span>-->
<!--                </span>-->
<!--                <span class="option-label">-->
<!--                    <span class="option-head">-->
<!--                        <span class="option-title">S/FTP Server</span>-->
<!--                        <span class="option-focus"><i class="fas fa-server"/></span>-->
<!--                    </span>-->
<!--                    <span class="option-body">-->
<!--                        Excel, CSV, TSV, XML, ...-->
<!--                    </span>-->
<!--                </span>-->
<!--            </label>-->
<!--        </div>-->
<!--        <div class="col-xl-3 col-md-6 pl-md-3">-->
<!--            <label class="option cursor-pointer opacity-50" :class="{'option-selected': value === 'api'}">-->
<!--                <span class="option-control">-->
<!--                    <span class="radio">-->
<!--                        <input type="radio"-->
<!--                               name="import_type"-->
<!--                               value="api"-->
<!--                               :checked="'api' === value"-->
<!--                               @input="$emit('input', 'api')"-->
<!--                        >-->
<!--                    </span>-->
<!--                </span>-->
<!--                <span class="option-label">-->
<!--                    <span class="option-head">-->
<!--                        <span class="option-title">API</span>-->
<!--                        <span class="option-focus"><i class="fas text-xl fa-network-wired"/></span>-->
<!--                    </span>-->
<!--                    <span class="option-body">-->
<!--                        API Endpunkt konfigurieren-->
<!--                    </span>-->
<!--                </span>-->
<!--            </label>-->
<!--        </div>-->
    </div>
</template>

<script>
export default {
    props: {
        value: String,
    },
}
</script>

<style lang="scss" scoped>
.fas {
    font-size: 2em;
    opacity: 0.75;
    margin-top: .2em;
}

.option-control {
    width: auto;
}

.option-selected {
    background: #795BF3;

    .option-title, .option-body {
        color: white !important;
    }

    .fas {
        color: white;
    }
}

.option-body {
    margin-top: -2.1em;
}
</style>
